module.exports = __webpack_public_path__ + "img/全程跟踪反馈@2x.197540d1.png";